/** null = all (no filter), [] = none selected, [ids] = partial selection */

export const MULTI_SELECT_ALL = null;

export function isMultiSelectAll(selectedIds, allCount) {
  if (selectedIds === null || selectedIds === undefined) return true;
  if (!Array.isArray(selectedIds)) return true;
  if (selectedIds.length === 0) return false;
  return allCount > 0 && selectedIds.length >= allCount;
}

export function isMultiSelectNone(selectedIds) {
  return Array.isArray(selectedIds) && selectedIds.length === 0;
}

export function multiSelectSummary(selectedIds, allCount, placeholder = 'الكل') {
  if (isMultiSelectAll(selectedIds, allCount)) {
    return allCount > 0 ? `${placeholder} (${allCount})` : placeholder;
  }
  if (isMultiSelectNone(selectedIds)) return 'لا شيء محدد';
  return `${selectedIds.length} محدد`;
}

/** Append filter param: omit when all, sentinel 0 when none, ids when partial */
export function appendMultiSelectFilter(params, selectedIds, allIds, key) {
  const allCount = allIds.length;
  if (isMultiSelectAll(selectedIds, allCount)) return;
  if (isMultiSelectNone(selectedIds)) {
    params[key] = '0';
    return;
  }
  if (selectedIds.length < allCount) {
    params[key] = selectedIds.join(',');
  }
}

export function cloneMultiSelectValue(selectedIds) {
  if (selectedIds === null || selectedIds === undefined) return null;
  return [...selectedIds];
}